import "./accountCancelViewSuccess.scss";

import Immutable from 'immutable';
import moment from 'moment';
import { i18n } from 'core/i18n';
const { formatText, FormattedText, getLanguage } = i18n;

import ContractSummary from 'routes/contractsView/components/ContractSummary/contractSummary';
import WizardSuccess from 'components/commons/wizardSuccess/wizardSuccess';

import DateHelper from 'utilities/dateHelper';

function AccountCancelViewSuccess(props) {
    const { immProfile, immAccount } = props;

    const setDetail = ({ title, value, type = undefined }) => ({
        columns: 12,
        title: title,
        ...(!!value && { body: value }),
        type: type,
    });

    const getFullDate = (date) => {
        return moment(date).locale(getLanguage()).format('LL');
    };

    const getDetails = () => {
        const {
            immAccount,
        } = props;

        if (!immAccount) {
            return [];
        }

        const alias = immAccount.get('alias');
        const iban = immAccount.get('iban');
        const todayDate = DateHelper.todayDate();

        return [
            [
                {
                    className: 'contract-summary__border-separator',
                    columns: 4,
                    details: [
                        setDetail({ title: formatText('cancellation_account-account_cancellation_request_step3_alias'), value: alias }),
                        setDetail({ title: formatText('accountDetails-accountType'), value: immAccount.get('descProducto').trim() }),
                        setDetail({
                            title: formatText('contractsView-applicationDate'),
                            value: getFullDate(todayDate),
                        })
                    ]
                },
                {
                    columns: 7,
                    offset: 1,
                    details: [
                        setDetail({
                            title: formatText('cancellation_account-account_cancellation_request_step3_iban'),
                            value: iban,
                        }),
                        setDetail({
                            title: formatText('cancellation_account-account_cancellation_request_step3_intervinientes'),
                            type: 'intervenerType'
                        })
                    ]
                }
            ]
        ]
    };

    const interveners = immAccount.get('interveners');
    const successWizardRequired = Immutable.fromJS({ state: { card_details: [] }, interveners: interveners.get('list'), })

    const mainButton = {
        label: formatText('nerudaUserCards-nerudaUserCards_goToAccountsLanding'),
        url: '/myprofile/accounts',
    };

    const subMessage = <div className="account-cancel-view-success__sub-message">
        <FormattedText value="cancellation_account-account_cancellation_request_success_subtitle" />
    </div>

    return (
        <div className="account-cancel-view-success">
            <WizardSuccess
                successMessage={formatText('cancellation_account-account_cancellation_request_success_title')}
                successSubMessage={subMessage}
                mainButton={mainButton}
            >
                <ContractSummary
                    immAccount={immAccount}
                    immProfileFields={immProfile}
                    details={getDetails()}
                    wizardState={successWizardRequired}
                    warningMessage={[]}
                />
            </WizardSuccess>
        </div>
    )
}

export default AccountCancelViewSuccess;